import { MetaFunction } from '@remix-run/node'

import { Breadcrumb, Container } from '~/components'
import { TopFooter, TopHeader, PrivacyPolicyPage } from '~/features'

export const meta: MetaFunction = ({ matches }) => {
  const parentMeta = matches
    .flatMap((match) => match.meta ?? [])
    .filter((meta) => !('title' in meta))
  return [
    ...parentMeta,
    {
      title:
        'プライバシーポリシー | シェアオフィス コワーキングスペース検索サイト',
    },
  ]
}

export default function Index() {
  return (
    <>
      <TopHeader />
      <Container className="pt-14">
        <Breadcrumb
          links={[
            { href: '/', text: 'トップ' },
            { text: 'プライバシーポリシー' },
          ]}
        />
      </Container>
      <PrivacyPolicyPage />
      <TopFooter />
    </>
  )
}
